export enum AlertTypeEnum {
	WARNING = 'warning',
	SUCCESS = 'success',
	ERROR = 'error',
	INFO = 'info',
}
